export const coachMeta = {
  bohdan: {
    name: "Bohdan",
    color: "#d1495b",
  },
  chigodo: {
    name: "Chigodo",
    color: "#2a9d8f",
  },
  bartosz: {
    name: "Bartosz",
    color: "#f4a261",
  },
};

const trainings = [
  {
    id: "mon-bohdan",
    dayKey: "monday",
    coachKey: "bohdan",
    location: {
      pl: "OSIR Mokotow, Niegocinska 2A",
      en: "OSIR Mokotow, Niegocinska 2A",
    },
    time: "17:30-19:00",
  },
  {
    id: "mon-chigodo",
    dayKey: "monday",
    coachKey: "chigodo",
    location: {
      pl: "OSIR Ochota, Nowowiejska 37B",
      en: "OSIR Ochota, Nowowiejska 37B",
    },
    time: "17:00-20:00",
  },
  {
    id: "tue-chigodo",
    dayKey: "tuesday",
    coachKey: "chigodo",
    location: {
      pl: "OSIR Ochota, Nowowiejska 37B",
      en: "OSIR Ochota, Nowowiejska 37B",
    },
    time: "17:00-20:00",
  },
  {
    id: "tue-bartosz",
    dayKey: "tuesday",
    coachKey: "bartosz",
    location: {
      pl: "AZS SGGW Football Arena",
      en: "AZS SGGW Football Arena",
    },
    time: "20:30-22:00",
  },
  {
    id: "thu-chigodo",
    dayKey: "thursday",
    coachKey: "chigodo",
    location: {
      pl: "OSIR Ochota, Nowowiejska 37B",
      en: "OSIR Ochota, Nowowiejska 37B",
    },
    time: "17:00-20:00",
  },
  {
    id: "thu-bohdan",
    dayKey: "thursday",
    coachKey: "bohdan",
    location: {
      pl: "Orlik, Worobczuka 8",
      en: "Orlik, Worobczuka 8",
    },
    time: "20:30-21:30",
  },
  {
    id: "fri-bohdan",
    dayKey: "friday",
    coachKey: "bohdan",
    location: {
      pl: "AWF Warszawa - boisko nr 3",
      en: "AWF Warsaw - Field No. 3",
    },
    time: "20:00-22:00",
  },
];

export default trainings;
